<template>
  <div>
    <div v-if="showMain">
      <!-- 顶部搜索框 -->
      <div class="usertop">
        <!-- 左侧搜索 -->
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item>
              <el-input class="w-208" @input="searchInput" @keydown.enter="search" v-model="formInline.name" clearable
                placeholder="名称/拼音">
                <template #suffix>
                  <div @click="search" class="searchcss">
                    <i class="fa fa-search"></i>
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button class="color-vice" type="primary" @click="exportTable">
            <i class="fa fa-arrow-down"></i>导出
          </el-button>
        </div>
      </div>
      <!-- 表格内容 -->
      <div>
        <div class="tip">
          <div><span class="lineSet color3"></span>停用</div>
          <div><span class="lineSet color2"></span>预警</div>
          <div><span class="lineSet color1"></span>正常</div>
        </div>
        <el-table size="small" v-loading="loading" stripe :data="tableData" style="width: 100%" max-height="64vh" border>
          <el-table-column label="状态" width="120" align="center">
            <template #default="scope">
              <el-tag type="warning" effect="dark" v-if="scope.row.store_warning == 1" style="margin-right: 2px;">
                预警
              </el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.is_enable == 0" style="margin-right: 2px;">
                停用
              </el-tag>
              <el-tag type="success" effect="dark" v-if="scope.row.store_warning == 0 && scope.row.is_enable == 1">
                正常
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="名称" width="180" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="规格" width="200" show-overflow-tooltip>
            <template #default="scope">
              <span>{{ scope.row.medi_spec }}</span>
            </template>
          </el-table-column>
          <el-table-column label="包装" width="120" show-overflow-tooltip>
            <template #default="scope">
              <span>{{ scope.row.min_package_num }} {{ scope.row.min_unit_name }}/
                {{ scope.row.min_package_unit_name }}</span>
            </template>
          </el-table-column>
          <el-table-column width="120" property="approval_no" label="国药准字" show-overflow-tooltip />
          <el-table-column width="180" property="company" label="厂家" show-overflow-tooltip />
          <el-table-column prop="dict_first_unit_name" label="销售单位" />
          <el-table-column label="库存数量" width="100">
            <template #default="scope">
              <span>
                {{ scope.row.store_num }} {{ scope.row.min_package_unit_name }}
                <template v-if="scope.row.store_sub_num">{{ scope.row.store_sub_num }} {{
                  scope.row.min_unit_name }}</template>
              </span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100" align="center">
            <template #default="scope">
              <el-link @click="getStoreDetail(scope.row)">
                库存明细
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination v-model:currentPage="pageData.currentPage" v-model:page-size="pageData.pageSize"
            :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.totalSum" @size-change="handleSizeChange"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </div>
    <storeDetail v-if="!showMain" ref="storeDetailRef" @closeStoreDetail="closeStoreDetail"></storeDetail>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted, nextTick } from 'vue'
import service from '@/utils/request'
import { gitDictList, Antishake,TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
import BaseDialog from '@/components/Dialog/index.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import storeDetail from './storeDetail'
export default {
  components: {
    BaseDialog,
    storeDetail
  },
  props: {
    dictCatalogType: {
      type: String,
      default: '',
    }
  },
  setup(props1) {
    const state = reactive({
      showMain: true,
      formInline: {
        name: '',
      },
      loading: true,
      pageData: {
        currentPage: 1,
        pageSize: 10,
        totalSum: 0,
      },
      tableData: [],
      storeDetailRef: null,
    })
    onMounted(() => {
      // tobody()
    })
    // 获取列表
    const tobody = async () => {
      state.loading = true
      let data = {
        size: state.pageData.pageSize,
        current: state.pageData.currentPage,
        name: state.formInline.name,
        dict_catalog_type: props1.dictCatalogType,
      }
      let res = await service.post('/api/storeEnterRecord/getDrugStoreList', data)
      if (res.code === 0) {
        if (res.data.total > 0) {
          state.tableData = res.data.records
          state.pageData.totalSum = res.data.total
          state.tableData.forEach(element => {
            element.pdEdit = false
          });
        } else {
          state.tableData = []
          state.pageData.totalSum = 0
        }
      }
      state.loading = false
    }
    // 条数改变时
    const handleSizeChange = (e) => {
      state.pageData.pageSize = e
      tobody()
    }
    // 页数改变时
    const handleCurrentChange = (e) => {
      state.pageData.currentPage = e
      tobody()
    }
    // 查询
    const search = () => {
      tobody()
    }

    // 导出
    const exportTable = () => {
      let data = {
        dict_catalog_type: props1.dictCatalogType,
      }
      let time = TimestampToTime()
      let title = ''
      title = `库存${time}.xlsx`
      downLoadXlsx('/api/Export/exportDrugStore', data, title)
    }
    const searchInput = () =>{
    Antishake(search(),2000)
  }
    // 库存明细
    const getStoreDetail = (row) => {
      state.showMain = false
      nextTick(() => {
        state.storeDetailRef.initData(row)
      })
    }

    // 关闭明细
    const closeStoreDetail = () => {
      state.showMain = true
      tobody()
    }

    return {
      ...toRefs(state),
      tobody,
      handleSizeChange,
      handleCurrentChange,
      search,
      exportTable,
      getStoreDetail,
      closeStoreDetail,
      searchInput
    }
  },
}
</script>

<style scoped lang="scss">
.displya_flex {
  display: flex;
  justify-content: space-between;
}

.usertop {
  margin-bottom: 8px;
  height: 35px;
  display: flex;
  justify-content: space-between;

  &:deep(.el-alert--warning.is-light) {
    background-color: rgba(49, 102, 174, 0.1);
    color: #3166ae;
  }
}

.tabctext {
  height: 20px;
  overflow: hidden;
  cursor: pointer;
  color: rgba(49, 102, 174, 1);
}
</style>
<style scoped lang="scss">
.adviceBox {
  height: 100%;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  padding: 10px;
}

.demo-tabs>.el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}

.display_flex {
  display: flex;
  justify-content: space-between;
}

.search-top .w-208 {
  width: 208px;

  .searchcss {
    cursor: pointer;
  }
}

.faicon {
  font-size: 19px;
  margin-right: 6px;
  cursor: pointer;
}

.title-top {
  align-items: center;
  display: flex;
}

.tabclis {
  height: 32px;
  background: rgba(49, 102, 174, 0.1);
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  display: flex;
  padding: 3px;

  .tabclis_right {
    display: flex;
    padding-top: 2px;
  }
}

/* .addform {
    .el-form {
      display: flex;
      flex-wrap: wrap;

      &:deep(.el-form-item__label) {
        width: 110px !important;
        text-align: right;
      }

      &:deep(.el-input) {
        width: 200px !important;
      }

      &:deep(.el-form-item) {
        width: 45% !important;
      }

      .mt_4 {
        &:deep(.el-input) {
          width: 100px !important;
        }
      }

      .parienttag {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .tag {
          margin-right: 8px;
          margin-bottom: 8px;
          color: #409eff;
          background-color: #ecf5ff;
          height: 20px;
          line-height: 20px;
          border-radius: 3px;
          text-align: center;
          font-size: 12px;
          padding: 0 10px;
          cursor: pointer;
        }

        .tags {
          margin-right: 8px;
          margin-bottom: 8px;
          background: #409eff;
          color: #ffffff;
          border-radius: 3px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          font-size: 12px;
          padding: 0 10px;
          cursor: pointer;
        }
      }
    }
  } */

.pagination-box {
  &:deep(.el-input__inner) {
    padding-right: 15px !important;
  }
}

.w-144 {
  margin-top: 20px;
}

.stop {
  background-color: #f4a939;
}

.modify {
  background-color: #3166ae;
}

.del {
  background-color: #ffecec;
  color: #ff6b6b;
  font-weight: 700;
}

.top {
  height: 35px;
  margin: 8px 0;
}

.nameSet {
  color: blue;
  cursor: pointer;
}

.labelSet1 {
  width: 60px;
  height: 30px;
  line-height: 30px;
  display: block;
  text-align: center;
  color: #fff;
  border-radius: 5px;
}

.lineSet {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  display: inline-block;
  margin-right: 10px;
}

.color {
  background-color: #fff;
}

.color1 {
  background-color: #67c23a;
}

.color2 {
  background-color: #cf784a;
}

.color3 {
  background-color: #f00;
}

.tip {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  line-height: 20px;

  div {
    margin-right: 20px;
  }
}
</style>